import { subtitleLandingMedium } from "assets/jss/material-kit-pro-react";


const donateButton = (theme) => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "18px"
  },
  paypalButton: {
    ...subtitleLandingMedium,
    textTransform: "capitalize !important",
    fontSize: "14px"
  }
});

export default donateButton;